define('score_bootstrap/Events/MultiViewSearchResultsEvent',["jquery"], function ($) {
    "use strict";

    function MultiViewSearchResultsEvent(value) {
        if (typeof value === "object") {
            $.extend(this, value);
        }
    }

    MultiViewSearchResultsEvent.hasMoreResults = "has-more-results";
    MultiViewSearchResultsEvent.noMoreResults = "no-more-results";
    

    return MultiViewSearchResultsEvent;
});
